export default {
    myLifestyle: 'My Lifestyle',
    results: 'Results'
};
